import {
  ChangeEvent,
  FunctionComponent,
  SyntheticEvent,
  useState,
} from "react";

import { Icon } from "../../Icon";

import NavBarMobileMenu from "./Menu";

import "./styles.scss";
import SectionsModal from "./Sections";
import SearchModal from "./Search";
import { useNavigate } from "react-router-dom";

type Props = {};

export enum NavbarModal {
  sections,
  searches,
  none,
}

const NavBarMobile: FunctionComponent<Props> = ({}) => {
  const { sections, searches, none } = NavbarModal;
  const [currentModal, setCurrentModal] = useState<NavbarModal>(none);
  const [search, setSearch] = useState("");

  const navigate = useNavigate();

  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    setSearch(e.target.value);
  };

  const handleSearch = (e: SyntheticEvent) => {
    setCurrentModal(none);
    e.preventDefault();
    navigate(`/search/${search}`);
  };

  const modal = {
    sections: currentModal === sections,
    search: currentModal === searches,
    none: currentModal === none,
  };

  const handleModal = (modal: NavbarModal) => {
    setCurrentModal(modal);
  };

  return (
    <section className="navbar-mobile" id="navBar">
      <section className="navbar-shadow"></section>
      <div onClick={() => navigate("/")}>
        <Icon iconName="rtabak_icon" className="rtabak-icon__mobile" />
      </div>
      <NavBarMobileMenu
        handleModal={(modal: NavbarModal) => handleModal(modal)}
      />
      {modal.sections && (
        <SectionsModal handleClose={() => setCurrentModal(none)} />
      )}
      {modal.search && (
        <SearchModal
          handleClose={() => setCurrentModal(none)}
          handleSearch={handleSearch}
          handleChange={handleChange}
        />
      )}
    </section>
  );
};
export default NavBarMobile;
